import {AutoComplete, Form, SelectPicker} from "rsuite";
import {commonMajors} from "../../../../constants/commonMajors";
import React, {useEffect, useState} from "react";
import {getDegrees} from "../../../../../service/dataService";

const EducationSearchForm = () =>  {

    const [degrees, setDegrees] = useState([]);

    useEffect(() => {
        getDegrees().then((data) => {
                // format the data into InputPicker format for now
                setDegrees(data.map(ele => ({label: ele.degreeName, value: ele.degreeName})));
            }
        );
    }, []);

    return (
        <>
            <Form.Group>
                <Form.ControlLabel>Degree Name</Form.ControlLabel>
                <Form.Control name="degreeName"
                              accepter={SelectPicker}
                              data={degrees}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Institution</Form.ControlLabel>
                <Form.Control name="institution"
                              style={{width: 400}}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Major</Form.ControlLabel>
                <Form.Control name="major"
                              accepter={AutoComplete}
                              data={commonMajors}
                              style={{width: 400}}
                />
            </Form.Group>
            <Form.Group>
                <Form.ControlLabel>Minor</Form.ControlLabel>
                <Form.Control name="minor"
                              style={{width: 400}}
                />
            </Form.Group>
        </>
    );
}

export default EducationSearchForm;